.center {
	overflow: hidden;
	flex-direction: column;
	justify-content: start;
	align-items: center;
}
.center > span {
	text-align: center;
	height: fit-content;
}
.center > span h1 {
	font-size: 2.5rem;
	font-weight: bold;
	margin: 0;
	padding: 0;
}
.contactList {
	width: 100%;

	height: calc(100vh - 130px - 1rem);
	padding: 1rem;
	background-color: var(--depth1);
	border-radius: var(--roundedBig);
	overflow-y: auto;
	display: flex;
	flex-wrap: wrap;
	gap: 1rem;
	justify-content: center;
	overflow: auto;
	position: relative;
}
.contactList::-webkit-scrollbar {
	background-color: transparent;
	width: 0.5rem;
}
.contactList::-webkit-scrollbar-thumb {
	background-color: var(--primary);
	border-radius: 1rem;
}

.contactList::-webkit-scrollbar-track-piece:end {
	background: var(--depth3);
	margin-bottom: 1rem;
	border-radius: 1rem;
}

.contactList::-webkit-scrollbar-track-piece:start {
	background: var(--depth3);
	border-radius: 1rem;

	margin-top: 4.5rem;
}
.contact {
	list-style: none;
	height: fit-content;

	display: flex;
	flex-direction: row;
	background-color: var(--depth2);
	border-radius: var(--roundedBig);
	cursor: pointer;
}
.contact:hover > div {
	background-color: var(--depth3);
}
.contact > div {
	background-color: var(--depth2);
	margin: 0px;
	width: 100%;
}
